import { createSlice } from '@reduxjs/toolkit'

export const errorSlice = createSlice({
  initialState: {},
  name: 'error',
  reducers: {
    reportError(state, action) {
      state.error = action.payload
    },
  },
})

export const { reportError } = errorSlice.actions
